import axios from "axios";

const instance = axios.create({
  baseURL: `https://comerciosclub.lavoz.com.ar`,
  headers: {
    Authorization: "Bearer 676840df68c9d332ef50e5ab48e75d5e",
  },
  timeout: 2000,
});

export default instance;
